module.exports = __webpack_public_path__ + "img/vacate.9de14744.svg";